export default {
    dashboard: {
        totalWordsGenerated: 'Parole totali generate.',
        wordsPerDay: 'Parole/giorno',
        content: 'Content => Contenuto',
        date: 'Data',
        variationCount: 'Variation Count -> Conteggio di variazione',
        transactionId: 'ID della transazione',
        totalWordsCount: 'Conteggio totale delle parole',
        action: 'Azione',
        goTo: 'vai a',
        viewMore: 'Visualizza di più',
        showLess: 'Mostra meno',
    },
};
